import { Component, inject } from '@angular/core';
import { LoadingService } from '../../core/services/loading.service';
import { LoadingStyleService } from '../../core/services/loading-style.service';

@Component({
  selector: 'app-road-loading-bar',
  standalone: true,
  styles: [`
    .track {
      background: repeating-linear-gradient(
        90deg, transparent 0 10px, rgba(232, 160, 32, .5) 10px 22px
      );
      background-size: 32px 100%;
      animation: dash-move .6s linear infinite;
    }
    @keyframes dash-move {
      from { background-position-x: 0; }
      to   { background-position-x: -32px; }
    }
    .car {
      animation: drive-across 1.6s linear infinite;
      filter: drop-shadow(0 1px 1px rgba(0, 0, 0, .35));
    }
    @keyframes drive-across {
      0%   { left: -6%; }
      100% { left: 106%; }
    }
  `],
  template: `
    @if (loading.isLoading() && style.style() === 'road') {
      <div class="fixed top-0 left-0 right-0 z-[200] h-[3px] pointer-events-none overflow-visible"
           role="status" aria-label="Loading">
        <div class="absolute inset-0 track"></div>
        <div class="absolute top-0 car" style="left: -6%">
          <svg width="18" height="11" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 9 L4 4 Q5 2 7 2 H15 Q17 2 18 4 L20 9"
                  stroke="#E8A020" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"
                  fill="rgba(232,160,32,0.25)"/>
            <line x1="1" y1="9" x2="21" y2="9" stroke="#E8A020" stroke-width="1.8" stroke-linecap="round"/>
            <circle cx="6" cy="10.5" r="1.8" fill="#E8A020"/>
            <circle cx="16" cy="10.5" r="1.8" fill="#E8A020"/>
          </svg>
        </div>
      </div>
    }
  `,
})
export class RoadLoadingBarComponent {
  readonly loading = inject(LoadingService);
  readonly style = inject(LoadingStyleService);
}
